import { Add, Remove } from '@mui/icons-material';
import { Box, IconButton, Stack } from '@mui/material';
import { HelperText, TextInputField } from '@shared/components';

interface Props {
  inputValue: string;
  error?: string;
  disabled?: boolean;
  fieldWidth?: 'small' | 'medium';
  setInputValue: (value?: string) => void;
}

export function InputWithStepper({
  inputValue,
  error,
  disabled,
  fieldWidth = 'medium',
  setInputValue,
}: Props) {
  return (
    <Stack>
      <Box display="flex" alignItems="center" textAlign="center">
        <IconButton
          sx={{ p: 0 }}
          disabled={!Number(inputValue) || Number(inputValue) < 0 || disabled}
          onClick={() => setInputValue(Number(inputValue) - 1 + '')}
        >
          <Remove />
        </IconButton>
        <TextInputField
          value={inputValue}
          disabled={disabled}
          onChange={(e) => setInputValue(e.target.value)}
          margin="none"
          sx={{
            minWidth: fieldWidth === 'small' ? 50 : 90,
            '& .MuiInputBase-root': {
              height: 28,
              width: fieldWidth === 'small' ? 50 : 90,
            },
          }}
        />
        <IconButton
          sx={{ p: 0 }}
          disabled={
            (isNaN(Number(inputValue)) && !!inputValue) || Number(inputValue) >= 21 || disabled
          }
          onClick={() => setInputValue(Number(inputValue ?? 0) + 1 + '')}
        >
          <Add />
        </IconButton>
      </Box>
      {error && (
        <HelperText id="errorText" status={'error'}>
          {error}
        </HelperText>
      )}
    </Stack>
  );
}
